import React from 'react';
import { Tag, TagProps } from 'antd';
import styled, { css, DefaultTheme } from 'styled-components';

type ThemeColor = keyof DefaultTheme['colors'];

export type ColoredTagTheme = {
  color: ThemeColor;
  border: ThemeColor;
  background: ThemeColor;
};

export const baseTagStyles = css`
  font-family: ${({ theme }) => theme.font.medium};
  font-size: 8px;
  height: 12px;
  letter-spacing: -0.16px;
  line-height: 10px;
  margin: 3px 0 0;
  padding: 0 4px;
  text-transform: uppercase;
  width: max-content;
`;

export const ColoredTag = styled(
  ({ tagTheme, ...props }: TagProps & { tagTheme: ColoredTagTheme }) => (
    <Tag {...props} />
  ),
)`
  ${baseTagStyles};
  background: ${({ theme, tagTheme }) => theme.colors[tagTheme.background]};
  border-color: ${({ theme, tagTheme }) => theme.colors[tagTheme.border]};
  border-radius: 2px;
  color: ${({ theme, tagTheme }) => theme.colors[tagTheme.color]};
`;
